import webApi from '../../webapi';

const getListaVendedores = async (codRevenda) => {
    const data = await webApi.get(`/Vendedor/revenda/${codRevenda}`);
    return data;
};

export { getListaVendedores };
